import { Col, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import {
  Dispatch,
  KeyboardEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';

import { FormFilter, InputForm, SelectForm } from 'components';
import Content from 'layouts/Content';
import { IRole } from 'interfaces/Role/Role';
import { DefaultOptionType } from 'antd/es/select';

interface IProps {
  open: boolean;
  roles: IRole[];
  jobTitles: any[];
  onFinish: (values: any) => void;
  setFilter: Dispatch<SetStateAction<any>>;
  setIsOpenFilter: Dispatch<SetStateAction<boolean>>;
}

const spanCol = 12;

const FilterPermission = ({
  open,
  roles,
  onFinish,
  setFilter,
  jobTitles,
}: IProps) => {
  const [form] = useForm();
  // const [roleOptions, setRoleOption] = useState<DefaultOptionType[]>();
  // const [jobTitleOptions, setJobTitleOptions] = useState<DefaultOptionType[]>();
  // useEffect(() => {
  //   const roleOptions = roles.map((role) => ({
  //     label: role.id,
  //     value: role.id,
  //     key: role.id,
  //   }));

  //   setRoleOption(roleOptions);
  //   const jobTitleOptions = jobTitles.map((jobTitle) => ({
  //     label: jobTitle.jobTitle,
  //     value: jobTitle.jobTitle,
  //     key: jobTitle.id,
  //   }));
  //   setJobTitleOptions(jobTitleOptions);
  // }, [roles, jobTitles]);

  const onCancel = () => {
    form.resetFields();
    setFilter({});
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      onFinish(form.getFieldsValue());
      e.preventDefault();
    }
  };

  return (
    <Content isOpen={open}>
      <FormFilter form={form} onFinish={onFinish} onCancel={onCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name={'fullName'} label="Tên nhân viên">
              <InputForm
                onKeyDown={handleKeyDown}
                name={'fullName'}
                placeholder="Nhập tên nhân viên"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name={'email'} label="Email">
              <InputForm
                onKeyDown={handleKeyDown}
                name={'email'}
                placeholder="Nhập email"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name="jobTitle" label="Chức vụ">
              {/* <SelectForm
                options={jobTitleOptions}
                placeholder="Chọn chức vụ"
              /> */}
              <InputForm placeholder="Nhập tên chức vụ" />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item name="role" label="Quyền">
              {/* <SelectForm options={roleOptions} placeholder="Chọn quyền" /> */}
              <InputForm placeholder="Nhập quyền" />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterPermission;
